
import React, { Component}  from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import { UserContext } from 'components/User';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { ScheduleForm } from './Form';
import { PreloadSchedule } from './PreloadSchedule';
import ScheduleDetailTable from './DetailTable';


export default class ScheduleAdd extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новая связка';
  }

  onDetail = (item) => {
    this.props.history.push(`/schedule`);
  };

  render() {
    const { match, location } = this.props;
    return (
      <FormProvider
        location={location}
        url={'schedule'}
        postSave={(item) => this.onDetail(item)}
        postSaveMessage={'Связка добавлена'}
        enterSubmit={false}
        item={{
          department: this.context.data.department_active,
          can_date_start_edit: true,
          status: 'WORKING'
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { item, loading } = context;
          return (
            <PreloadSchedule id={match.params.id} onUpdate={context.setValues}>
              <Layout>
                <Layout.Header
                  title={'Создание связки'}
                  backUrl={'/schedule'}
                />

                <Layout.ContentSimple>
                  <ScheduleForm />

                  <div className={'mt-30'}>
                    <YellowButton
                      onClick={(e) => context.handleSubmit(e)}
                      size={'large'}
                      disabled={loading}
                    >
                      Создать связку
                    </YellowButton>

                    <ScheduleDetailTable item={item} />

                  </div>
                </Layout.ContentSimple>
              </Layout>
            </PreloadSchedule>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
